<template>
  <div
    id='counter_container'
    class="mx-2 my2"
  >
    <div style="flex-shrink: 1;">
        <span
          class="static box mx2 bold medium"
          :class="{is_valid: countDown.days !== '-'}"
        >{{ countDown.days }}</span>
      <div class="center_text">
        <b>{{ $t('cms.view.DaysLabel') }}</b>
      </div>
    </div>

    <div style="flex-shrink: 1;">
        <span
          class="static box mx2 bold medium"
          :class="{is_valid: countDown.hours !== '-'}"
        >{{  countDown.hours }}</span>
      <div class="center_text">
        <b>{{ $t('cms.view.HoursLabel') }}</b>
      </div>
    </div>

    <div style="flex-shrink: 1;">
        <span
          class="static box mx2 bold medium"
          :class="{is_valid: countDown.minutes !== '-'}"
        >{{ countDown.minutes }}</span>
      <div class="center_text">
        <b>{{ $t('cms.view.MinutesLabel') }}</b>
      </div>
    </div>

    <div style="flex-shrink: 1;">
      <div
        class="static box mx2"
        :class="{is_valid: countDown.seconds !== '-'}"
      >
        <span class="bold medium" style="color: #f1bc19;">{{ countDown.seconds }}</span>
      </div>
      <div class="center_text">
        <b>{{ $t('cms.view.SecondsLabel') }}</b>
      </div>
    </div>
  </div>
</template>

<script>
import { withTimezone } from '@/utils/date_utils';
import store from '@/store';

export default {
  name: 'countdown',

  props: {
    to: { type: Date, required: false, default: null },
  },

  data() {
    return {
      now: withTimezone(new Date(), store.getTimeZone()),
      EMPTY_COUNTDOWN: {
        days: '0',
        hours: '0',
        minutes: '0',
        seconds: '0',
      },
    };
  },

  created() {
    if (this.to) {
      this.interval = setInterval(() => {
        this.now = withTimezone(new Date(), store.getTimeZone());
      }, 1000);
    }
  },

  destroyed() {
    clearInterval(this.interval);
  },

  computed: {
    countDown() {
      if (!this.to) { return this.EMPTY_COUNTDOWN; }

      const distanceInMS = this.to - this.now;

      if (Number.isNaN(distanceInMS) || distanceInMS < 999) { return this.EMPTY_COUNTDOWN; }

      return {
        days: Math.floor(distanceInMS / (1000 * 60 * 60 * 24)),
        hours: Math.floor((distanceInMS % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
        minutes: Math.floor((distanceInMS % (1000 * 60 * 60)) / (1000 * 60)),
        seconds: Math.floor((distanceInMS % (1000 * 60)) / 1000),
      };
    },
  },
};

</script>

<style lang="scss">
  #counter_container {
    display: flex;
    flex-wrap: nowrap;
    justify-content: center;
    margin-top: 12px;

    .box {
      min-width: 24px;
    }
  }
</style>
